import { render, staticRenderFns } from "./TrackersHealth.vue?vue&type=template&id=9a5a19e0&"
import script from "./TrackersHealth.vue?vue&type=script&lang=js&"
export * from "./TrackersHealth.vue?vue&type=script&lang=js&"
import style0 from "./TrackersHealth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports